import styles from './EmptyStateDataDisplay.module.css';

import { Icon } from 'components/Icon';

export interface EmptyStateDataDisplayProps {
  /** The main text to display. */
  label: string;
  /** The sub-text to display. */
  paragraph: string;
}

/** Represents a component to indicate an empty state. */
export function EmptyStateDataDisplay({ label, paragraph }: EmptyStateDataDisplayProps) {
  return (
    <div className={styles['empty-state-data-display_wrapper']}>
      <div className={styles['empty-state-data-display_icon-frame']}>
        <Icon name="CubeTransparent" />
      </div>
      <div className={styles['empty-state-data-display_text-content']}>
        <label className={styles['empty-state-data-display_label']}>{label}</label>
        <p className={styles['empty-state-data-display_paragraph']}>{paragraph}</p>
      </div>
    </div>
  );
}
